import { render } from "./ProjectTeamsModal.vue?vue&type=template&id=57515418"
import script from "./ProjectTeamsModal.vue?vue&type=script&lang=js"
export * from "./ProjectTeamsModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__